// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__cdaZG","info-text":"Contact_info-text__p18uj","button-container":"Contact_button-container__aeRnT","button":"Contact_button__f6323"};